import React, { useState } from 'react';
import classNames from 'classnames';
import { variants as iconVariants, sizes as iconSizes } from '../icon/style';

// components
import Icon from '../icon';
import { Span } from '../box';

const StarsRating = ({
  onChange,
  value,
  variant = 'sun',
  className,
  size = 'xxl',
  max = 5,
}: {
  onChange?: (index: number, event: React.MouseEvent) => void;
  value?: number;
  variant?: keyof typeof iconVariants;
  className?: string;
  size?: keyof typeof iconSizes;
  max?: number;
}) => {
  const [hoverRate, setHoverRate] = useState<number>(-1);

  return (
    <div
      data-testid={'stars-rating'}
      style={{ display: 'flex' }}
      data-value={value}
      className={classNames('box-stars-rating', className)}
      onMouseLeave={() => setHoverRate(0)}
    >
      {new Array(max).fill(null).map((item, index) => {
        index = index + 1; //need to be not zero based
        const isActive = index <= hoverRate || index <= (value || 0);

        return (
          <Span
            role={'button'}
            tabIndex={0}
            aria-label={`rating star number ${index}`}
            onClick={e => onChange?.(index, e)}
            marginRight={'xs'}
            key={index}
          >
            <Icon
              onMouseEnter={() => setHoverRate(index)}
              className={classNames({ active: isActive }, { empty: !isActive })}
              data-name={'stars-rating'}
              data-value={index}
              clickable
              variant={isActive ? variant : 'gray300'}
              name={'STAR'}
              size={size}
            />
          </Span>
        );
      })}
    </div>
  );
};

export default StarsRating;
